import { FC, useState } from 'react';

import { Image, ImageProps } from './Image';

type Props = ImageProps & {
  hoverImageSrc?: string;
};

const HoverableImage: FC<Props> = ({ hoverImageSrc, ...imageProps }) => {
  const [loaded, setLoaded] = useState(false);

  if (!hoverImageSrc) {
    return <Image {...imageProps} />;
  }

  return (
    <div className="relative w-full">
      <Image onLoad={() => setLoaded(true)} {...imageProps} />

      {hoverImageSrc && loaded && (
        <div className="absolute inset-0 opacity-0 transition duration-300 ease-out group-hover:opacity-100">
          <Image
            alt={imageProps.alt}
            size={imageProps.size}
            src={hoverImageSrc}
          />
        </div>
      )}
    </div>
  );
};

export default HoverableImage;
